import Auth from "cp-client-auth!sofe";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import { featureEnabled } from "feature-toggles!sofe";
import canopyUrls from "canopy-urls!sofe";

import { handleError } from "../handle-error";

export async function pendoBootstrap() {
  if (!featureEnabled("toggle_pendo_script")) return;

  const envMap = {
    [canopyUrls.DEVELOPMENT_ENVIRONMENT]: "dev",
    [canopyUrls.INTEGRATION_ENVIRONMENT]: "integ",
    [canopyUrls.STAGING_ENVIRONMENT]: "stage",
    [canopyUrls.PRODUCTION_ENVIRONMENT]: "prod",
    [canopyUrls.WHITELABEL_ENVIRONMENT]: "whitelabel",
  };
  const env = envMap[canopyUrls.getEnvironment()] || "dev";

  forkJoin([
    Auth.getLoggedInUserAsObservable().pipe(take(1)),
    Auth.getTenantAsObservable().pipe(take(1)),
  ]).subscribe(([loggedInUser, tenant]) => {
    if (window.pendo) {
      const { id, email, name, tenantId, licenses } = loggedInUser;
      const { crm_status } = tenant;

      window.pendo.initialize({
        visitor: {
          id: env === "prod" ? id : `${env}-${id}`,
          tenantId,
          email,
          name,
        },
        account: {
          id: env === "prod" ? tenantId : `${env}-${tenantId}`,
          licenses,
          crm_hierarchy: crm_status === "crm_hierarchy_complete",
        },
      });
    }
  }, handleError);
}
